import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import auth from "./Reducers/auth/reducers.js";
import profile from "./Pages/profile/Reducers/profile";
import bedrijven from "./Pages/Admin/Bedrijven/Reducers/bedrijven";
import website from "./Pages/Website/Reducers/website";
import push from "./Pages/profile/Reducers/Push";
import loading from "./Reducers/loading/loading";
import gebruikers from "./Pages/Admin/Gebruikers/Reducers/gebruikers";
import theme from "./Pages/Thema/Recucers/theme/theme.js";
import items from "./Pages/Items/Reducers/items/items.js";
import arrangementen_wild from "./Pages/Items/Reducers/arrangementen/arrangementen.js";
import events from "./Pages/Evemenenten/Reducers/events/events.js";
import ervaringen from "./Pages/Ervaringen/Reducers/ervaringen.js";
import boekingen from "./Pages/Boekingen/Reducers/boekingen.js";
import cms from "./Pages/CMS/Reducers/cms.js";
import connections from "./Pages/Admin/Connections/Reducers/connections.js";
import vacatures from "./Pages/Vacatures/Reducers/vacatures.js";
import arrangementen from "./Pages/Arrangementen/Reducers/arrangementen.js";
import reserveringssystemen from "./Pages/Admin/Reserveringssystemen/Reducers/reserveringssystemen.js";
import betaalmethodes from "./Pages/Admin/Betaalmethodes/Reducers/index.js";
import toegangscontrole from "./Pages/Admin/Toegangscontrole/Reducers/index.js";
import apiKeys from "./Pages/Admin/ApiKeys/Reducers/index.js";
import loginAttempts from "./Reducers/LoginAttempts/index.js";
import userorganisaties from "./Pages/Admin/UserOrganisaties/Reducers/userorganisaties.js";

export default combineReducers({
  auth,
  profile,
  bedrijven,
  website,
  push,
  loading,
  gebruikers,
  theme,
  items,
  events,
  ervaringen,
  boekingen,
  cms,
  arrangementen,
  connections,
  vacatures,
  arrangementen_wild,
  reserveringssystemen,
  betaalmethodes,
  toegangscontrole,
  apiKeys,
  loginAttempts,
  userorganisaties,
  form: formReducer,
});
